import { cn } from 'cn';

type P = {
  /** Whether the dot should display as active (filled) or inactive (hollow) */
  isActive?: boolean;
};

/**
 * Visual indicator dot for tree items.
 * Positioned absolutely to sit on the tree connector line.
 */
export function Dot({ isActive = false }: P) {
  return (
    <div
      className={cn(
        'absolute z-10 size-4 -translate-x-[9.5px] -translate-y-4 rounded-full border-2 bg-white',
        {
          'border-tiga-text-default': isActive,
          'border-tiga-border-default': !isActive,
        },
      )}
    />
  );
}
